var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rn-back-top",class:[_vm.visible ? 'd-inline' : 'd-none'],on:{"click":_vm.scrollToTop}},[_c('Icon',{attrs:{"name":"arrow-up","size":"27"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }